import React from 'react';
import { useTranslation } from '../i18n';

interface LoaderProps {
  minHeight?: number;
}

const Loader: React.FC<LoaderProps> = ({ minHeight = 100 }) => {
  const { t } = useTranslation();
  
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight }}>
      <div className="spinner-border d-block" role="status">
        <span className="visually-hidden">{t('general.loading_ellipsis')}</span>
      </div>
    </div>
  );
};

export default Loader;
